//# sourceMappingURL=tooltip.mjs.map
/// <reference types="./tooltip.d.mts" />
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $event from "../../../redraw/redraw/event.mjs";
import * as $dom from "../../../redraw_dom/redraw/dom.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $mouse from "../../../redraw_dom/redraw/dom/event/mouse.mjs";
import * as $e from "../../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $length from "../../../sketch/sketch/css/length.mjs";
import { px } from "../../../sketch/sketch/css/length.mjs";
import * as $h_ from "../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $position from "../../ds/position.mjs";
import { Ok, toList, CustomType as $CustomType, makeError } from "../../gleam.mjs";

const FILEPATH = "src/ds/components/tooltip.gleam";

export class Props extends $CustomType {
  constructor(content, position, style, disabled) {
    super();
    this.content = content;
    this.position = position;
    this.style = style;
    this.disabled = disabled;
  }
}
export const Props$Props = (content, position, style, disabled) =>
  new Props(content, position, style, disabled);
export const Props$isProps = (value) => value instanceof Props;
export const Props$Props$content = (value) => value.content;
export const Props$Props$0 = (value) => value.content;
export const Props$Props$position = (value) => value.position;
export const Props$Props$1 = (value) => value.position;
export const Props$Props$style = (value) => value.style;
export const Props$Props$2 = (value) => value.style;
export const Props$Props$disabled = (value) => value.disabled;
export const Props$Props$3 = (value) => value.disabled;

/**
 * Left positioning, should be used with `tooltip.position`.
 */
export const left = /* @__PURE__ */ new $position.Left();

/**
 * Right positioning, should be used with `tooltip.position`.
 */
export const right = /* @__PURE__ */ new $position.Right();

/**
 * Attribute to position the tooltip. Should be used with `tooltip.left` &
 * `tooltip.right`.
 */
export function position(props, position) {
  return new Props(props.content, position, props.style, props.disabled);
}

export function element(content) {
  return new Props(content, new $position.Left(), toList([]), false);
}

export function style(props, style) {
  return new Props(props.content, props.position, style, props.disabled);
}

export function disabled(props, disabled) {
  return new Props(props.content, props.position, props.style, disabled);
}

function tooltip_container(parent_position, position, children) {
  let _pipe = $css.class$(
    toList([
      $css.position("fixed"),
      $css.max_width(px(450)),
      $css.z_index(10_000_000),
      $position.vertical(parent_position),
      $position.horizontal(parent_position, position),
    ]),
  );
  return $h_.div(_pipe, toList([]), children);
}

function view_tooltip(tooltip, opened, position, parent_position) {
  return $bool.lazy_guard(
    !opened,
    $h.none,
    () => {
      if (parent_position instanceof Some) {
        let parent_position$1 = parent_position[0];
        let tooltip$1 = tooltip_container(
          parent_position$1,
          position,
          toList([tooltip]),
        );
        let $ = $dom.create_portal(tooltip$1, "tooltip");
        let portal;
        if ($ instanceof Ok) {
          portal = $[0];
        } else {
          throw makeError(
            "let_assert",
            FILEPATH,
            "ds/components/tooltip",
            139,
            "view_tooltip",
            "Pattern match failed, no pattern matched the value.",
            {
              value: $,
              start: 4178,
              end: 4239,
              pattern_start: 4189,
              pattern_end: 4199
            }
          )
        }
        return portal;
      } else {
        return $h.none();
      }
    },
  );
}

function position_wrapper(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.position("relative"),
      $css.display("flex"),
      $css.align_items("center"),
    ]),
  );
  return $position.div(_pipe, attrs, children);
}

function on_mouse_leave(set_opened, set_parent) {
  return $e.on_mouse_leave(
    (_) => {
      set_opened(false);
      return set_parent(new None());
    },
  );
}

function on_mouse_enter(set_opened, set_parent) {
  return $e.on_mouse_enter(
    (event) => {
      let event$1 = $mouse.as_event(event);
      let target = $event.target(event$1);
      let $ = $position.parent(target);
      if ($ instanceof Ok) {
        let parent = $[0];
        set_opened(true);
        return set_parent(new Some(parent));
      } else {
        return undefined;
      }
    },
  );
}

/**
 * Used to render a tooltip. Due to the nature of a tooltip, it's not displayed
 * by default, but display on hover on some parts of the DOM.
 *
 * `tooltip` accepts three arguments: `attributes` to pass some attributes to
 * the custom elements, `content` used to render the content on which the mouse
 * event handlers are bind and on which it's possible to hover to display the
 * tooltip, and `tooltip` itself to define the content of the displayed
 * tooltip.
 *
 * ```gleam
 * fn my_tooltip() {
 *   let content = html.div([], [html.text("Hover me to display the tooltip!")])
 *   tooltip.tooltip(tooltip.props(content) |> tooltip.position(left), {
 *     html.div([], [
 *       html.text("This content will be displayed in the tooltip, "),
 *       html.text("and only in the tooltip!"),
 *     ])
 *   })
 * }
 * ```
 */
export function tooltip() {
  return $redraw.component_(
    "Tooltip",
    (_use0) => {
      let props = _use0[0];
      let tooltip$1 = _use0[1];
      let $ = $redraw.use_state(false);
      let opened = $[0];
      let set_opened = $[1];
      let $1 = $redraw.use_state(new None());
      let parent = $1[0];
      let set_parent = $1[1];
      let on_mouse_enter$1 = on_mouse_enter(set_opened, set_parent);
      let on_mouse_leave$1 = on_mouse_leave(set_opened, set_parent);
      return position_wrapper(
        toList([$a.style(props.style)]),
        toList([
          $h.div(
            toList([on_mouse_leave$1, on_mouse_enter$1]),
            toList([props.content]),
          ),
          view_tooltip(
            tooltip$1,
            opened && !props.disabled,
            props.position,
            parent,
          ),
        ]),
      );
    },
  );
}
